/** Message slide variant — italic body with breathing candlelight halo +
 *  ghost quote mark. */
import type { VariantProps } from '../registry';

export function MessageVariant({ slide }: VariantProps) {
  const text = slide.contentText || 'Your message…';
  return (
    <div className="preview-slide-content relative">
      <div className="preview-candle-glow" aria-hidden />
      <div
        className="preview-ghost-quote"
        style={{ fontSize: '10rem' }}
        aria-hidden
      >
        “
      </div>
      <p className="preview-slide-message">{text}</p>
    </div>
  );
}
